// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__J0t7T","leftTitle":"styles_leftTitle__ULuQx"};